export default __webpack_public_path__ + "static/media/5.16e5e1eb.webp";